import { Component, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-business-filter-dialog',
  templateUrl: './business-filter-dialog.component.html',
  styleUrls: ['./business-filter-dialog.component.scss']
})
export class BusinessFilterDialogComponent {
  filters: any;
  headList: any[];
  isDropdownOpen: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<BusinessFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('Filter dialog data received:', data);
    this.filters = { ...data.filters };
    // Transform head list to include display text
    this.headList = (data.headList || []).map(head => ({
      ...head,
      displayText: `${head.emp_id} -  (${head.email})`
    }));
    // Ensure name exists for binding
    if (this.filters.name === undefined || this.filters.name === null) {
      this.filters.name = '';
    }
  }

  // Custom dropdown methods
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectOption(head: any): void {
    this.filters.head_id = head.emp_id;
    this.isDropdownOpen = false;
  }

  getSelectedLabel(): string {
    const selected = this.headList.find(head => head.emp_id === this.filters.head_id);
    return selected ? selected.displayText : '';
  }

  // Handle escape key press
  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent): void {
    this.close();
  }

  // Handle clicking outside the dialog
  onOverlayClick(event: MouseEvent): void {
    // Only close if clicking directly on the overlay, not on dialog content
    if (event.target === event.currentTarget) {
      this.close();
    }
    // Close dropdown when clicking outside
    this.isDropdownOpen = false;
  }

  applyFilters(): void {
    this.dialogRef.close(this.filters);
  }

  clearFilters(): void {
    this.filters = { name: '', head_id: '' };
  }

  close(): void {
    this.dialogRef.close();
  }
}